import React from 'react';
import { Box, Container, Typography, Link, Divider, Stack } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import {
  GitHub as GitHubIcon,
  LinkedIn as LinkedInIcon,
  Twitter as TwitterIcon
} from '@mui/icons-material';

const Footer: React.FC = () => {
  const navItems = [
    { name: 'Home', path: '/' },
    { name: 'Projects', path: '/projects' },
    { name: 'About', path: '/about' },
    { name: 'Contact', path: '/contact' },
  ];

  return (
    <Box sx={{ 
      bgcolor: 'background.paper', 
      py: 6,
      borderTop: '1px solid',
      borderColor: 'divider'
    }}>
      <Container maxWidth="lg">        
        <Box sx={{ 
          display: 'flex', 
          flexDirection: { xs: 'column', md: 'row' }, 
          justifyContent: 'space-between',
          alignItems: { xs: 'center', md: 'flex-start' },
          gap: 4
        }}>
          <Box sx={{ mb: { xs: 3, md: 0 }, textAlign: { xs: 'center', md: 'left' } }}>
            <Typography variant="h6" gutterBottom sx={{ fontWeight: 700 }}>
              KHD
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ maxWidth: '300px' }}>
              Principal Engineer specialized in designing and building exceptional digital experiences.
            </Typography>
            
            <Stack direction="row" spacing={2} sx={{ mt: 2 }}>
              <Link 
                href="https://github.com/KHeavyy" 
                target="_blank" 
                sx={{ color: 'text.secondary', '&:hover': { color: 'primary.main' } }}
              >
                <GitHubIcon fontSize="small" />
              </Link>
              <Link 
                href="https://www.linkedin.com/in/keith-dick-7967789a/" 
                target="_blank" 
                sx={{ color: 'text.secondary', '&:hover': { color: 'primary.main' } }}
              >
                <LinkedInIcon fontSize="small" />
              </Link>
              <Link 
                href="https://x.com/kheavy" 
                target="_blank" 
                sx={{ color: 'text.secondary', '&:hover': { color: 'primary.main' } }}
              >
                <TwitterIcon fontSize="small" />
              </Link>
            </Stack>
          </Box>

          <Box sx={{ textAlign: { xs: 'center', md: 'left' } }}>
            <Typography variant="subtitle2" gutterBottom color="primary">
              Navigation
            </Typography>
            {navItems.map((item) => (
              <Typography 
                key={item.name} 
                variant="body2" 
                component={RouterLink} 
                to={item.path}
                sx={{ 
                  display: 'block', 
                  mb: 1, 
                  color: 'text.secondary',
                  textDecoration: 'none',
                  '&:hover': { color: 'primary.main' }
                }}
              >
                {item.name}
              </Typography>
            ))}
          </Box>
        </Box>
        
        <Divider sx={{ my: 4 }} />
        
        <Typography variant="body2" color="text.secondary" textAlign="center">
          © {new Date().getFullYear()} KHD. All rights reserved.
        </Typography>
      </Container>
    </Box>
  );
};

export default Footer;
